import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';


// Context
import { OverviewConsumer } from 'pages/Overview/OverviewContext';


// Config
import { featureGroups, toolbarOptions } from 'pages/Overview/config';


// CSS
import styles from './styles.css';


// Lodash
import { find, get, indexOf } from 'lodash';


// Images
import Check from '../images/optimized/checkmark.svg';


// Local config
const CONFIG = {
	source: 'toolbar'
};


/**
 * Features panel, containing open type and stylistic set options
 *
 * @method Features
 * @param  {Object} values  Collection of slider values pulled from state.
 * @return {Node}
 */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
class Features extends React.PureComponent {
	render() {
		const { featuresPanelRef, isOpen } = this.props;

		return (
			<OverviewConsumer>
				{ ({ putSetting, settings }, ssCounter = 0) =>
					<div className={ classNames(styles.panel, { [styles['panel--active']]: isOpen }) } ref={ featuresPanelRef }>
						<div className={ styles.panelInterior }>
							<div className={ styles['column--features'] }>
								<h4 className={ styles.h4 }>Features</h4>
								<ul className={ styles.featureList }>
									{ toolbarOptions.openTypeFeatures.map((item, index) => {
										const hasThisSetting = indexOf(get(settings, 'otFeatures.value', null), item.value) > -1;
										const isFigureSetting = indexOf(featureGroups.figures, item.value) > -1;
										const isEnabled = !!find(get(settings, 'selectedStyle.features', null), { code: item.value });

										if (!isEnabled) { return false; }

										const itemClasses = classNames(
											styles.checkbox,
											{
												[styles.radio]: isFigureSetting,
												[styles.CheckListItem]: !hasThisSetting,
												[styles.checked]: hasThisSetting
											}
										);

										return (
											<li
												aria-checked={ hasThisSetting }
												className={ itemClasses }
												key={ `ffs__${index}` }
												onMouseDown={ event => {
													putSetting({ type: 'TOGGLE_OPENTYPE_FEATURE', value: item.value, silent: false, source: CONFIG.source });
													event.preventDefault();
												} }
												role="checkbox"
											>
												{ !isFigureSetting && <Check className={ styles.check } /> }
												{ item.label }
											</li>
										);
									})}
								</ul>
							</div>
							{ get(settings, 'selectedStyle.stylisticSets.length', 0) > 0 &&
								<div className={ styles['column--stylisticSets'] }>
									<h4 className={ styles.h4 }>Stylistic Sets</h4>
									<ul className={ styles.featureList }>
										{ toolbarOptions.stylisticSets.map((item, index) => {
											const hasThisSetting = indexOf(get(settings, 'stylisticSets.value', 0), item.value) > -1;
											const isEnabled = !!find(get(settings, 'selectedStyle.stylisticSets'), { code: item.value });
											let description = get(settings, `selectedStyle.stylisticSets[${ssCounter}]`, null);

											// Descriptions come from the DB formatted with the SS# at the front
											// (SS09 - Description is here). We need to remose the first bit.
											description = !!description && description.description.split(' - ')[0];
											description = isEnabled && description ? description : null;

											if (!isEnabled) { return false; }

											ssCounter += 1; // eslint-disable-line no-param-reassign

											return (
												<li
													aria-checked={ hasThisSetting }
													className={
														classNames(
															styles.checkbox,
															{ [styles.checked]: hasThisSetting }
														)
													}
													key={ `ffs__${index}` }
													onMouseDown={ event => {
														putSetting({ type: 'TOGGLE_STYLISTIC_SET', value: item.value, silent: false, source: CONFIG.source });
														event.preventDefault();
													} }
													role="checkbox"
												>
													<Check className={ styles.check } />
													{ description }
												</li>
											);
										})}
									</ul>
								</div>
							}
						</div>
					</div>
				}
			</OverviewConsumer>
		);
	}
}
/* eslint-enable jsx-a11y/no-noninteractive-element-to-interactive-role */

Features.propTypes = {
	featuresPanelRef: PropTypes.func,
	isOpen: PropTypes.bool
};

Features.defaultProps = {
	featuresPanelRef: null,
	isOpen: false
};

export default Features;
